import { type AnalyticsEvent } from '@backstage/core-plugin-api';
import { type MetricRequest } from '@internal/plugin-neo4j-analytics-common';

import { BaseAnalyticsEventHandler } from './types';

export class NotFoundEventHandler extends BaseAnalyticsEventHandler {
  readonly eventName = 'not-found';
  readonly metricName = 'notfound';

  canHandle(action: string): boolean {
    return action === this.eventName;
  }

  handle(event: AnalyticsEvent): MetricRequest[] {
    if (!this.canHandle(event.action)) {
      return [];
    }

    return [
      {
        kind: 'counter',
        name: this.getMetricName(this.metricName),
        value: 1,
        attributes: {
          kind: event.attributes?.kind || this.sentinelMissingValue,
          plugin: event.context.pluginId,
          to: event.subject,
          entity_ref: event.context.entityRef || this.sentinelMissingValue,
        },
        options: {
          description: 'Total number of pages not found',
          unit: '1',
          valueType: 'int',
        },
      },
    ];
  }
}
